import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Download, User } from "lucide-react";
import api, { setupAxiosInterceptors } from "./axiosSetup";
import CustomNavbar from "./CustomNavbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/DownloadList.css";

const DownloadList = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setupAxiosInterceptors(navigate);
    fetchFiles();
  }, [navigate]);

  const fetchFiles = async () => {
    setLoading(true);
    setErrorMsg(null);
    try {
      const token = localStorage.getItem("authToken");
      const response = await api.get("/api/files", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFiles(response.data || []);
    } catch (error) {
      console.error("Fehler beim Laden der Dateien:", error);
      setErrorMsg("Fehler beim Laden der Dateien. Bitte versuche es später erneut.");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (filename, originalname) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await api.get(`/api/files/download/${filename}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", originalname);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Fehler beim Herunterladen:", error);
      // Die Antwort kommt als Blob zurueck, der Text muss erst herausgelesen
      // werden - sonst bliebe die Meldung des Servers unsichtbar.
      let text = "Fehler beim Herunterladen der Datei.";
      try {
        const roh = await error.response?.data?.text?.();
        if (roh) text = JSON.parse(roh).message || text;
      } catch {
        /* Standardmeldung behalten */
      }
      setErrorMsg(text);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    return d.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <>
      <CustomNavbar />
      <div className="container mt-4">
        <h3 className="fw-bold mb-1 text-white">📂 Dateiübersicht</h3>
        <p className="mb-4" style={{ color: "white" }}>
          Hier findest du alle von der Zunft bereitgestellten Dateien.
        </p>

        {loading && <p style={{ color: "white" }}>Lade Dateien...</p>}
        {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}

        {!loading && files.length === 0 && (
          <p className="mt-3" style={{ color: "white" }}>
            Aktuell sind keine Dateien verfügbar.
          </p>
        )}

        {!loading && files.length > 0 && (
          <div className="row g-3">
            {files.map((file) => (
              <div key={file.id} className="col-12 col-md-6 col-lg-4">
                <div className="file-card shadow-sm p-3 rounded-4 h-100 d-flex flex-column justify-content-between bg-dark" style={{ color: "white" }}>
                  <div className="d-flex align-items-start gap-3">
                    <FileText size={36} className="text-primary" />
                    <div className="flex-grow-1">
                      <h5 className="fw-semibold mb-1" style={{ color: "white" }}>
                        {file.description || "Ohne Titel"}
                      </h5>
                      <div style={{ color: "white" }}>{file.originalname}</div>
                      <div className="mt-1 d-flex align-items-center gap-1" style={{ color: "white" }}>
                      hochgeladen von: <User size={14} /> {file.uploader || "Unbekannt"}
                      </div>
                      <div style={{ color: "white" }}>
                        hochgeladen am: 📅 {formatDate(file.upload_date)}
                      </div>
                    </div>
                  </div>

                  {file.vorhanden === false ? (
                    <div className="alert alert-warning mt-3 mb-0 py-2 text-center">
                      Die Datei liegt nicht mehr auf dem Server.
                    </div>
                  ) : (
                    <button
                      className="btn btn-primary w-100 mt-3 d-flex align-items-center justify-content-center gap-2"
                      onClick={() => handleDownload(file.filename, file.originalname)}
                    >
                      <Download size={18} /> Herunterladen
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        <br/>
        <br/>
      </div>
    </>
  );
};

export default DownloadList;
